function InsuranceIcon({ type }) {
  if (type === "car") {
    return (
      <svg viewBox="0 0 96 72" className="h-16 w-20" role="img" aria-label="Car insurance icon">
        <path d="M15 42L28 28H62L79 34L84 50H15V42Z" fill="#ffffff" opacity="0.96" />
        <path d="M31 30L40 22H60L71 30" fill="#ffffff" opacity="0.82" />
        <circle cx="31" cy="52" r="8" fill="#14304a" />
        <circle cx="69" cy="52" r="8" fill="#14304a" />
        <circle cx="31" cy="52" r="4" fill="#ffffff" />
        <circle cx="69" cy="52" r="4" fill="#ffffff" />
      </svg>
    );
  }

  if (type === "bike") {
    return (
      <svg viewBox="0 0 72 72" className="h-16 w-16" role="img" aria-label="Bike insurance icon">
        <circle cx="18" cy="48" r="10" fill="none" stroke="#ffffff" strokeWidth="5" />
        <circle cx="54" cy="48" r="10" fill="none" stroke="#ffffff" strokeWidth="5" />
        <path
          d="M18 48L31 31H44L54 48M31 31L38 48M28 27H38"
          fill="none"
          stroke="#ffffff"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "commercial") {
    return (
      <svg
        viewBox="0 0 64 64"
        className="h-14 w-14"
        role="img"
        aria-label="Commercial insurance icon"
      >
        <rect x="14" y="12" width="36" height="40" rx="6" fill="#ffffff" opacity="0.95" />
        <path d="M24 52V38H40V52" fill="#14304a" opacity="0.16" />
        <path
          d="M23 22H27M23 30H27M37 22H41M37 30H41M23 38H27M37 38H41"
          stroke="#14304a"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "health") {
    return (
      <svg viewBox="0 0 64 64" className="h-16 w-16" role="img" aria-label="Health insurance icon">
        <path
          d="M32 50C20 43 14 35 14 26C14 18 20 14 26 14C30 14 33 16 35 19C37 16 40 14 44 14C50 14 56 18 56 26C56 35 50 43 38 50L35 52L32 50Z"
          fill="#ffffff"
          opacity="0.96"
        />
        <path d="M32 21V37M24 29H40" stroke="#63c7ab" strokeWidth="5" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === "life") {
    return (
      <svg viewBox="0 0 64 64" className="h-16 w-16" role="img" aria-label="Life insurance icon">
        <path
          d="M32 48C22 48 16 42 16 34C16 28 20 24 26 24C29 24 31 25 32 27C33 25 35 24 38 24C44 24 48 28 48 34C48 42 42 48 32 48Z"
          fill="#ffffff"
          opacity="0.96"
        />
        <circle cx="32" cy="20" r="6" fill="#ffffff" opacity="0.96" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 64 64" className="h-16 w-16" role="img" aria-label="Term insurance icon">
      <path
        d="M32 10L48 17V30C48 39 42 47 32 50C22 47 16 39 16 30V17L32 10Z"
        fill="#ffffff"
        opacity="0.96"
      />
      <path
        d="M26 30L30 34L38 25"
        fill="none"
        stroke="#14304a"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

window.AppComponents = window.AppComponents || {};
window.AppComponents.InsuranceIcon = InsuranceIcon;
